import { createContext } from 'react';
import type { StringIndexedObject } from '@kanda-libs/ks-component-ts';

interface LineItemContextValue {
  total?: number;
  price?: number;
  vat?: number;
  quantity?: number;
  isLoading?: boolean;
  title?: string;
  description?: string;
  quoteDocument?: StringIndexedObject;
  classNames?: StringIndexedObject;
  style?: string;
}

const Context = createContext<LineItemContextValue>({});

Context.displayName = 'LineItem-Context';

export default Context;
